import { createBrowserHistory, createMemoryHistory } from 'history'

/**
 * Shared history instance used by both the client-side <Router> and any
 * component that needs to navigate imperatively (e.g. calendarHeader).
 *
 * Replaces the react-router v3 `browserHistory` singleton, which no longer
 * exists in react-router v5. On the server there is no DOM, so we fall back
 * to an in-memory history (its push is a no-op for SSR).
 */
const history =
  typeof window !== 'undefined' ? createBrowserHistory() : createMemoryHistory()

export default history
